import { useMemo } from 'react';

import type { Key } from 'react-aria-components/Menu';

import { type SelectedKeys, toSelectedKeys } from '../utils/selection_change';

export function useSelectedKeys<ItemKey extends Key>(
  selection: ItemKey | SelectedKeys<ItemKey> | null | undefined,
) {
  return useMemo(() => toSelectedKeys(selection), [selection]);
}
